import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CardContent, CardHeader, IconButton, Typography, useTheme, Collapse } from '@mui/material';
import { useState } from 'react';
import BackgroundPattern from '@public/assets/images/event-card-bg.png';
import StyledCard from '@ui/pages/Home/components/FullHeightCard/StyledCard';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
const GlobalSearchCard = ({ padding, variant = 'light', icon, heading, children, bgPattern = false, bgPosition, onClick, haveHeader = true, innerHeading = false, sx, chips, accordion = false, defaultExpanded = true, customButton, contentPadding = false, slider = false, disableBackground = false, disableShadow = false, textAlignCenter = false }) => {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(defaultExpanded);
    const getBgPatternStyles = (position) => ({
        backgroundImage: `url(${BackgroundPattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: position,
        backgroundSize: 'cover'
    });
    return (_jsxs(StyledCard, { customVariant: variant, disableBackground: disableBackground, disableShadow: disableShadow, sx: [
            {
                // fixed-height cards will work because content can flex inside
                display: 'flex',
                flexDirection: 'column',
                height: accordion ? 'auto' : '100%',
                overflow: 'hidden',
                borderRadius: theme.spacing(3),
                flexShrink: accordion ? 0 : undefined
            },
            ...(bgPattern ? [getBgPatternStyles(bgPosition || 'top -105px left 10px')] : []),
            ...(Array.isArray(sx) ? sx : [sx || {}])
        ], onClick: !accordion ? onClick : undefined, children: [haveHeader && (_jsx(CardHeader, { sx: {
                    '& .MuiCardHeader-content': {
                        minWidth: 0
                    }
                }, avatar: icon && icon, title: (heading || (chips && chips.length > 0)) && (_jsx(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, children: heading && (_jsx(Typography, { whiteSpace: innerHeading ? 'nowrap' : undefined, textOverflow: innerHeading ? 'ellipsis' : undefined, overflow: innerHeading ? 'hidden' : undefined, textAlign: textAlignCenter ? 'center' : undefined, variant: innerHeading ? 'caption' : 'h6', color: variant === 'light' ? theme.palette.text.primary : theme.palette.common.white, fontWeight: innerHeading ? 400 : 500, fontSize: innerHeading ? '12px' : undefined, children: heading })) })), action: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [slider && customButton, accordion && (_jsx(IconButton, { onClick: () => setExpanded((prev) => !prev), sx: {
                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s',
                                border: 'none'
                            }, children: _jsx(ExpandMoreIcon, { sx: { color: theme.palette.text.tertiary } }) })), !slider && customButton] }) })), _jsx(Collapse, { in: !accordion || expanded, children: _jsx(CardContent, { sx: {
                        padding: padding,
                        position: 'relative',
                        '&:last-child': { paddingBottom: contentPadding ? 0 : 1 },
                        display: 'flex',
                        flexDirection: 'column',
                        flex: accordion ? 'none' : 1,
                        minHeight: 0,
                        overflow: 'hidden'
                    }, children: children }) })] }));
};
export default GlobalSearchCard;
